import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8427cb26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container nav-bar fs-3 px-4 py-2 text-center" }
const _hoisted_2 = { class: "fs-7 align-text-bottom" }
const _hoisted_3 = { class: "fs-7 align-text-bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
    _withDirectives(_createElementVNode("span", _hoisted_2, "上線", 512), [
      [_vShow, _ctx.store.state.showIsOnline && _ctx.store.state.connected]
    ]),
    _withDirectives(_createElementVNode("span", _hoisted_3, "離線", 512), [
      [_vShow, _ctx.store.state.showIsOnline && !_ctx.store.state.connected]
    ])
  ]))
}